import React from 'react';
import { Button } from './ui/button';

const CategoryTabs = ({ categories, activeCategory, onCategoryChange, darkMode = false }) => {
  return (
    <div className={`sticky top-0 z-40 border-b ${darkMode ? 'bg-gray-900 border-gray-700' : 'bg-white border-gray-200'}`} style={{ top: 'var(--header-height, 120px)' }}>
      <div className="px-4 py-3 overflow-x-auto">
        <div className="flex gap-2 min-w-max">
          {categories.map((category) => (
            <Button
              key={category.id}
              onClick={() => onCategoryChange(category.id)}
              className={
                activeCategory === category.id
                  ? 'bg-blue-700 hover:bg-blue-800 text-white rounded-full px-6'
                  : darkMode
                    ? 'bg-gray-700 hover:bg-gray-600 text-gray-200 rounded-full px-6'
                    : 'bg-gray-100 hover:bg-gray-200 text-gray-700 rounded-full px-6'
              }
              variant={activeCategory === category.id ? 'default' : 'secondary'}
            >
              {category.name}
            </Button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default CategoryTabs;